import { ProductionPiece } from 'app/models/ProductionPiece';

export const getPickingDescription = (piece: ProductionPiece): string => {
  const isCabinetDoor =
    piece.type === 'door' &&
    (piece.cabinet != null || piece.product?.cabinet != null);

  return piece.product?.uniqueProduct && !isCabinetDoor
    ? piece.product.name ?? ''
    : piece.descriptionHTML ?? '';
};
